import LegalLayout, { LegalSection } from "../components/legal/LegalLayout";
import { NC } from "../components/landing/shared";

export default function TermsPage() {
  return (
    <LegalLayout title="Terms & Conditions" updated="JUNE 2026" testId="terms-page">
      <LegalSection n="01" title="Acceptance of These Terms">
        <p>
          These Terms &amp; Conditions ("Terms") govern your use of this website, the VA Better-Buy Masterclass™,
          and related communications from Shoreline Mortgage Group ("we," "us," or "our"). By using this website,
          registering for the masterclass, or submitting a form, you agree to these Terms and to our Privacy
          Policy.
        </p>
      </LegalSection>

      <LegalSection n="02" title="SMS / Text Messaging Terms (A2P 10DLC)">
        <p>
          <span className="font-semibold text-white/80">Program description:</span> By providing your mobile number
          and checking the consent box, you agree to receive text messages from Shoreline Mortgage Group related to
          the VA Better-Buy Masterclass™ and your requests — including registration confirmations, event
          reminders, replay availability, and follow-up about a Better Deal Review™ you have requested.
        </p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><span className="text-white/80 font-semibold">Message frequency varies.</span></li>
          <li><span className="text-white/80 font-semibold">Message and data rates may apply.</span> Charges are billed by your mobile carrier.</li>
          <li><span className="text-white/80 font-semibold">Opt out:</span> reply <span className="font-mono-strict">STOP</span> to any message to cancel. You will receive a single confirmation message, after which no further messages will be sent unless you opt in again.</li>
          <li><span className="text-white/80 font-semibold">Help:</span> reply <span className="font-mono-strict">HELP</span> to any message, or contact us using the details at the bottom of this page.</li>
          <li><span className="text-white/80 font-semibold">Consent is not a condition</span> of any purchase, service, or loan.</li>
          <li>Carriers are not liable for delayed or undelivered messages.</li>
          <li>Your text messaging originator opt-in data and consent will not be shared with or sold to any third parties, as described in our Privacy Policy.</li>
        </ul>
      </LegalSection>

      <LegalSection n="03" title="Educational Content — Not a Commitment to Lend">
        <p>
          The masterclass, its replay, and all content on this website are educational. Attending, watching, or
          registering does not constitute a loan application, an approval, an offer of credit, or a commitment to
          lend. All loans are subject to a complete application, credit approval, income and asset verification,
          property eligibility, appraisal, and program guidelines. Nothing on this website is a quote or a
          guarantee of eligibility, rate, payment, fees, costs, savings, timing, or closing. VA-backed loan
          programs are administered by the U.S. Department of Veterans Affairs; Shoreline Mortgage Group is not
          endorsed by or affiliated with the VA or any government agency. Equal Housing Opportunity.
        </p>
      </LegalSection>

      <LegalSection n="04" title="Eligibility & Service Area">
        <p>
          This website and its offers are intended for adults (18+) exploring VA-backed home financing in Florida
          and Pennsylvania, the states in which Josh Bartlett (NMLS# 1425493) is licensed.
        </p>
      </LegalSection>

      <LegalSection n="05" title="Your Responsibilities">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Provide accurate, current information in any form you submit</li>
          <li>Only provide a mobile number that belongs to you or that you are authorized to enroll</li>
          <li>Notify us if you change or deactivate your mobile number</li>
          <li>Use this website only for lawful, personal, non-commercial purposes</li>
        </ul>
      </LegalSection>

      <LegalSection n="06" title="Intellectual Property">
        <p>
          All content on this website — including the VA Better-Buy Masterclass™, the Better Deal Method™, the
          Better Deal Review™, text, graphics, and design — is the property of Shoreline Mortgage Group or its
          licensors and is protected by applicable intellectual property laws. You may not copy, reproduce, or
          distribute it without written permission.
        </p>
      </LegalSection>

      <LegalSection n="07" title="Disclaimers & Limitation of Liability">
        <p>
          This website is provided "as is" without warranties of any kind, express or implied. To the fullest
          extent permitted by law, Shoreline Mortgage Group is not liable for indirect, incidental, or
          consequential damages arising from your use of this website or participation in the masterclass. Nothing
          in these Terms limits rights you may have under applicable consumer protection laws.
        </p>
      </LegalSection>

      <LegalSection n="08" title="Governing Law">
        <p>
          These Terms are governed by the laws of the State of Florida, without regard to conflict-of-law
          principles, except where the law of your state of residence is required to apply.
        </p>
      </LegalSection>

      <LegalSection n="09" title="Changes to These Terms">
        <p>
          We may update these Terms from time to time. The "Last Updated" date at the top of this page reflects the
          most recent revision. Continued use of the website after changes are posted constitutes acceptance of the
          updated Terms.
        </p>
      </LegalSection>

      <LegalSection n="10" title="Company Information">
        <p>
          Shoreline Mortgage Group · Josh Bartlett, Branch Manager · NMLS# 1425493 (client-submitted, pending
          verification) · Company NMLS# <NC label="COMPANY NMLS" /> · Licensed in Florida and Pennsylvania ·{" "}
          <NC label="LEGAL ENTITY / POWERED-BY WORDING" />
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
